import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a2c71232&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a2c71232&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c71232",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2c71232')) {
      api.createRecord('a2c71232', component.options)
    } else {
      api.reload('a2c71232', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a2c71232&scoped=true", function () {
      api.rerender('a2c71232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/merbershipSystems/dashboard/index.vue"
export default component.exports